
export const phoneTemplateImages: Record<string, {
    template: string;
    glossy: string;
    matte: string;
    glossyMagSafe?: string;
    matteMagSafe?: string;
}> = {
    "8": { template: "/phone_templates/8.png", glossy: "61521", matte: "61522" },
    "8_plus": { template: "/phone_templates/8_plus.png", glossy: "61523", matte: "61524" },
    "x": { template: "/phone_templates/x.png", glossy: "61525", matte: "61526" },
    "xr": { template: "/phone_templates/xr.png", glossy: "61529", matte: "61530" },
    "xs": { template: "/phone_templates/xs.png", glossy: "61531", matte: "61532" },
    "xs_max": { template: "/phone_templates/xs_max.png", glossy: "61533", matte: "61534" },
    "11": { template: "/phone_templates/11.png", glossy: "63234", matte: "63235" },
    "11_pro": { template: "/phone_templates/11_pro.png", glossy: "63236", matte: "63237" },
    "11_pro_max": { template: "/phone_templates/11_pro_max.png", glossy: "63238", matte: "63239" },
    "12": { template: "/phone_templates/12.png", glossy: "67998", matte: "67999" },
    "12_mini": { template: "/phone_templates/12_mini.png", glossy: "67996", matte: "67997" },
    "12_pro": { template: "/phone_templates/12_pro.png", glossy: "68000", matte: "68001" },
    "12_pro_max": { template: "/phone_templates/12_pro_max.png", glossy: "68002", matte: "68003" },
    "13": { template: "/phone_templates/13.png", glossy: "75383", matte: "75384", glossyMagSafe: "149141", matteMagSafe: "149142" },
    "13_mini": { template: "/phone_templates/13_mini.png", glossy: "75385", matte: "75386", glossyMagSafe: "MAGSAFE_ID", matteMagSafe: "MAGSAFE_ID" },
    "13_pro": { template: "/phone_templates/13_pro.png", glossy: "75387", matte: "75388", glossyMagSafe: "149143", matteMagSafe: "149144" },
    "13_pro_max": { template: "/phone_templates/13_pro_max.png", glossy: "75389", matte: "75390", glossyMagSafe: "149145", matteMagSafe: "149146" },
    "14": { template: "/phone_templates/14.png", glossy: "96397", matte: "96398", glossyMagSafe: "109336", matteMagSafe: "109337" },
    "14_plus": { template: "/phone_templates/14_plus.png", glossy: "96401", matte: "96402", glossyMagSafe: "109340", matteMagSafe: "109341" },
    "14_pro": { template: "/phone_templates/14_pro.png", glossy: "96399", matte: "96400", glossyMagSafe: "109338", matteMagSafe: "109339" },
    "14_pro_max": { template: "/phone_templates/14_pro_max.png", glossy: "96403", matte: "96404", glossyMagSafe: "109342", matteMagSafe: "109343" },
    "15": { template: "/phone_templates/15.png", glossy: "102547", matte: "102548", glossyMagSafe: "109328", matteMagSafe: "109329" },
    "15_plus": { template: "/phone_templates/15_plus.png", glossy: "102549", matte: "102550", glossyMagSafe: "109332", matteMagSafe: "109333" },
    "15_pro": { template: "/phone_templates/15_pro.png", glossy: "102551", matte: "102552", glossyMagSafe: "109330", matteMagSafe: "109331" },
    "15_pro_max": { template: "/phone_templates/15_pro_max.png", glossy: "102553", matte: "102554", glossyMagSafe: "109334", matteMagSafe: "109335" },
    "16": { template: "/phone_templates/16.png", glossy: "112191", matte: "112192", glossyMagSafe: "112613", matteMagSafe: "112614" },
    "16_plus": { template: "/phone_templates/16_plus.png", glossy: "112193", matte: "112194", glossyMagSafe: "112615", matteMagSafe: "112616" },
    "16_pro": { template: "/phone_templates/16_pro.png", glossy: "112195", matte: "112196", glossyMagSafe: "112609", matteMagSafe: "112610" },
    "16_pro_max": { template: "/phone_templates/16_pro_max.png", glossy: "112197", matte: "112198", glossyMagSafe: "112611", matteMagSafe: "112612" },
    "air": { template: "/phone_templates/air.png", glossy: "129875", matte: "129876", glossyMagSafe: "129534", matteMagSafe: "129535" },
    "17": { template: "/phone_templates/17.png", glossy: "129873", matte: "129874", glossyMagSafe: "129532", matteMagSafe: "129533" },
    "17_pro": { template: "/phone_templates/17_pro.png", glossy: "129877", matte: "129878", glossyMagSafe: "129536", matteMagSafe: "129537" },
    "17_pro_max": { template: "/phone_templates/17_pro_max.png", glossy: "129879", matte: "129880", glossyMagSafe: "129538", matteMagSafe: "129539" },
    "gp6": { template: "/phone_templates/gp6.png", glossy: "79421", matte: "79422" },
    "gp6_pro": { template: "/phone_templates/gp6_pro.png", glossy: "98740", matte: "98741" },
    "gp7": { template: "/phone_templates/gp7.png", glossy: "98738", matte: "98739" },
    "gp8": { template: "/phone_templates/gp8.png", glossy: "105154", matte: "105155" },
    "gp8_pro": { template: "/phone_templates/gp8_pro.png", glossy: "105154", matte: "105155" },
    "gp9": { template: "/phone_templates/gp9.png", glossy: "116386", matte: "116387" },
    "gp9_pro": { template: "/phone_templates/gp9_pro.png", glossy: "116388", matte: "116389" },
    "gp9_pro_xl": { template: "/phone_templates/gp9_pro_xl.png", glossy: "116390", matte: "116391" },
    "s10": { template: "/phone_templates/s10.png", glossy: "61801", matte: "61805" },
    "s10_e": { template: "/phone_templates/s10_e.png", glossy: "61797", matte: "61798" },
    "s10_plus": { template: "/phone_templates/s10_plus.png", glossy: "61800", matte: "61804" },
    "s20": { template: "/phone_templates/s20.png", glossy: "65225", matte: "65226" },
    "s20_fe": { template: "/phone_templates/s20_fe.png", glossy: "79423", matte: "79424" },
    "s20_plus": { template: "/phone_templates/s20_plus.png", glossy: "65229", matte: "65230" },
    "s20_ultra": { template: "/phone_templates/s20_ultra.png", glossy: "65227", matte: "65228" },
    "s21": { template: "/phone_templates/s21.png", glossy: "77841", matte: "77842" },
    "s21_fe": { template: "/phone_templates/s21_fe.png", glossy: "79425", matte: "79426" },
    "s21_plus": { template: "/phone_templates/s21_plus.png", glossy: "77843", matte: "77844" },
    "s21_ultra": { template: "/phone_templates/s21_ultra.png", glossy: "77845", matte: "77846" },
    "s22": { template: "/phone_templates/s22.png", glossy: "80152", matte: "80153" },
    "s22_plus": { template: "/phone_templates/s22_plus.png", glossy: "80154", matte: "80155" },
    "s22_ultra": { template: "/phone_templates/s22_ultra.png", glossy: "80156", matte: "80157" },
    "s23": { template: "/phone_templates/s23.png", glossy: "96738", matte: "96739" },
    "s23_plus": { template: "/phone_templates/s23_plus.png", glossy: "96740", matte: "96741" },
    "s23_ultra": { template: "/phone_templates/s23_ultra.png", glossy: "96742", matte: "96743" },
    "s24": { template: "/phone_templates/s24.png", glossy: "105148", matte: "105149" },
    "s24_plus": { template: "/phone_templates/s24_plus.png", glossy: "105150", matte: "105151" },
    "s24_ultra": { template: "/phone_templates/s24_ultra.png", glossy: "105152", matte: "105153" },
    "s25": { template: "/phone_templates/s25.png", glossy: "117862", matte: "117863" },
    "s25_plus": { template: "/phone_templates/s25_plus.png", glossy: "117864", matte: "117865" },
    "s25_ultra": { template: "/phone_templates/s25_ultra.png", glossy: "117866", matte: "117867" },
    "s26": { template: "/phone_templates/s25.png", glossy: "244207", matte: "244208" },
    "s26_plus": { template: "/phone_templates/s25_plus.png", glossy: "244209", matte: "244210" },
    "s26_ultra": { template: "/phone_templates/s25_ultra.png", glossy: "244211", matte: "244212" },
};



export const iOSPhones = [
    { name: 'iPhone 8', value: '8' },
    { name: 'iPhone 8 Plus', value: '8_plus' },
    { name: 'iPhone X', value: 'x' },
    { name: 'iPhone XR', value: 'xr' },
    { name: 'iPhone XS', value: 'xs' },
    { name: 'iPhone XS Max', value: 'xs_max' },
    { name: 'iPhone 11', value: '11' },
    { name: 'iPhone 11 Pro', value: '11_pro' },
    { name: 'iPhone 11 Pro Max', value: '11_pro_max' },
    { name: 'iPhone 12', value: '12' },
    { name: 'iPhone 12 Mini', value: '12_mini' },
    { name: 'iPhone 12 Pro', value: '12_pro' },
    { name: 'iPhone 12 Pro Max', value: '12_pro_max' },
    { name: 'iPhone 13', value: '13' },
    { name: 'iPhone 13 Mini', value: '13_mini' },
    { name: 'iPhone 13 Pro', value: '13_pro' },
    { name: 'iPhone 13 Pro Max', value: '13_pro_max' },
    { name: 'iPhone 14', value: '14' },
    { name: 'iPhone 14 Plus', value: '14_plus' },
    { name: 'iPhone 14 Pro', value: '14_pro' },
    { name: 'iPhone 14 Pro Max', value: '14_pro_max' },
    { name: 'iPhone 15', value: '15' },
    { name: 'iPhone 15 Plus', value: '15_plus' },
    { name: 'iPhone 15 Pro', value: '15_pro' },
    { name: 'iPhone 15 Pro Max', value: '15_pro_max' },
    { name: 'iPhone 16', value: '16' },
    { name: 'iPhone 16 Plus', value: '16_plus' },
    { name: 'iPhone 16 Pro', value: '16_pro' },
    { name: 'iPhone 16 Pro Max', value: '16_pro_max' },
    { name: 'iPhone Air', value: 'air' },
    { name: 'iPhone 17', value: '17' },
    { name: 'iPhone 17 Pro', value: '17_pro' },
    { name: 'iPhone 17 Pro Max', value: '17_pro_max' },

];

export const androidPhones = [

    { name: 'Pixel 6', value: 'gp6' },
    { name: 'Pixel 6 Pro', value: 'gp6_pro' },
    { name: 'Pixel 7', value: 'gp7' },
    { name: 'Pixel 8', value: 'gp8' },
    { name: 'Pixel 8 Pro', value: 'gp8_pro' },
    { name: 'Pixel 9', value: 'gp9' },
    { name: 'Pixel 9 Pro', value: 'gp9_pro' },
    { name: 'Pixel 9 Pro XL', value: 'gp9_pro_xl' },

    { name: 'Galaxy S10', value: 's10' },
    { name: 'Galaxy S10 e', value: 's10_e' },
    { name: 'Galaxy S10 Plus', value: 's10_plus' },
    { name: 'Galaxy S20', value: 's20' },
    { name: 'Galaxy S20 FE', value: 's20_fe' },
    { name: 'Galaxy S20 Plus', value: 's20_plus' },
    { name: 'Galaxy S20 Ultra', value: 's20_ultra' },
    { name: 'Galaxy S21', value: 's21' },
    { name: 'Galaxy S21 FE', value: 's21_fe' },
    { name: 'Galaxy S21 Plus', value: 's21_plus' },
    { name: 'Galaxy S21 Ultra', value: 's21_ultra' },
    { name: 'Galaxy S22', value: 's22' },
    { name: 'Galaxy S22 Plus', value: 's22_plus' },
    { name: 'Galaxy S22 Ultra', value: 's22_ultra' },
    { name: 'Galaxy S23', value: 's23' },
    { name: 'Galaxy S23 Plus', value: 's23_plus' },
    { name: 'Galaxy S23 Ultra', value: 's23_ultra' },
    { name: 'Galaxy S24', value: 's24' },
    { name: 'Galaxy S24 Plus', value: 's24_plus' },
    { name: 'Galaxy S24 Ultra', value: 's24_ultra' },
    { name: 'Galaxy S25', value: 's25' },
    { name: 'Galaxy S25 Plus', value: 's25_plus' },
    { name: 'Galaxy S25 Ultra', value: 's25_ultra' },
    { name: 'Galaxy S26', value: 's26' },
    { name: 'Galaxy S26 Plus', value: 's26_plus' },
    { name: 'Galaxy S26 Ultra', value: 's26_ultra' },
];